export function findRoute(routes, name,parentPath) {
  for (const route of routes) {
    if (route.path === name||route.name === name) {
      route.path=parentPath&&(!route.path.includes(parentPath))?(parentPath+'/'+route.path):route.path
      return route
    }
    if (route.children && route.children.length > 0) {
      const found = findRoute(route.children, name,route.path)
      if (found) {
        return found
      }
    }
  }
  return null
}
